import { useRef, useState, useEffect } from "react";
import {
  IconButton,
  MenuItem,
  ClickAwayListener,
  Fade,
  Paper,
  Popper,
  MenuList,
  Typography,
} from "@mui/material";
import {
  setEditConnectionOpen,
  setEditConnectionId,
  setEditSchemaOpen,
  setSelectedConnection,
} from "@/features/connections/integrationSlice";
import { MoreVertIcon } from "@/ImageRepo";
import "./ThreeDotSettingMenu.css";
import { useDispatch } from "react-redux";
import { idID } from "@mui/material/locale";
const ThreeDotSettingMenu = ({ id, selectedRow }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const editConnectionClicked = (id) => {
    dispatch(setEditConnectionId(id));
    dispatch(setEditConnectionOpen(true));
    dispatch(setSelectedConnection({ selectedConnectionInfo: selectedRow }));

    // heap.io
    window.heap.track("Connections Manager - Edit Connection");
  };

  const editSchemaClicked = (selectedRow) => {
    dispatch(setEditConnectionId(selectedRow.ConnectionId));
    dispatch(setSelectedConnection({ selectedConnectionInfo: selectedRow }));
    dispatch(setEditSchemaOpen(true));

    // heap.io
    window.heap.track("Connections Manager - Edit Schema");
  };
  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleToggle}
        style={{ padding: "0px 10px" }}
        disableRipple
      >
        <MoreVertIcon className="more-vert-icon" />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="left-start"
        transition
        className={"three-dot-menu"}
      >
        {({ TransitionProps, placement }) => (
          <Fade {...TransitionProps} timeout={500}>
            <Paper
              sx={{
                borderRadius: "6px",
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  sx={{
                    borderRadius: "6px",
                    padding: "8px 6px 8px 6px !important",
                    fontFamily: "var(--font-family)",
                  }}
                >
                  <MenuItem
                    className="menu-options"
                    onClick={() => {
                      editConnectionClicked(id);
                    }}
                  >
                    <Typography>Edit Connection</Typography>
                  </MenuItem>
                  <MenuItem
                    className="menu-options"
                    onClick={() => {
                      editSchemaClicked(selectedRow);
                    }}
                  >
                    <Typography>Edit Schema</Typography>
                  </MenuItem>
                  <MenuItem className="menu-options">
                    <Typography>View log</Typography>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default ThreeDotSettingMenu;
